export default __webpack_public_path__ + "3c224c573983d38b63240469e5b4c168.png";